(function () {
    'use strict';
    /**
     * Main controller for IBCOSE view
     */
    angular
        .module('ib-check-in-search')
        .controller('CheckInSearchController', CheckInSearchController);//Controller for IBCOSE view

    CheckInSearchController.$inject = ['$rootScope', '$scope', 'ModalService', 'CkiDatalayerUtilsService', 'CkiDatalayerConstants', '$window', '$timeout', 'CheckInSearchModel', 'CheckinSearchService', 'CheckinAppConstants', '$location', 'localStorageService', 'UtilsService', 'SearchFlightsPassengersService', 'ComponentUtils', 'MonetateUtilsService', 'MonetateConstants', 'RedirectionService', '$filter', 'CkiDataLayerService'];
    function CheckInSearchController ($rootScope, $scope, ModalService, CkiDatalayerUtilsService, CkiDatalayerConstants, $window, $timeout, CheckInSearchModel, CheckinSearchService, CheckinAppConstants, $location, localStorageService, UtilsService, SearchFlightsPassengersService, ComponentUtils, MonetateUtilsService, MonetateConstants, RedirectionService, $filter, CkiDataLayerService) {
        const vm = this;
        vm.addOnType;
        vm.model = CheckInSearchModel;
        vm.formIberiaPlus;

        //ctrl functions
        vm.openGenericModal = openGenericModal;
        vm.isValidateForm = isValidateForm;
        vm.submitForm = submitForm;
        vm.moreInfoRedirection = moreInfoRedirection;
        vm.onError = onError;
        vm.showWaitingModal = showWaitingModal;
        vm.afterLogin = afterLogin;
        vm.updateDatalayerByQuadrigam = updateDatalayerByQuadrigam;
        vm.initModel = initModel;

        $scope.$on('anonymousSubmit', (event, data) => {
            initBooking(data.pnr, data.surname);
        });

        //Delete all calls to openGenericModal
        $scope.$on('openGenericModal',
            (event, size, tpl, anim) => {
                openGenericModal(size, tpl, anim);
            });
        const bannerRenderedEvent = $rootScope.$on('bannerRenderedEvent', (event, containsAd) => {
            $rootScope.$apply(() => {
                vm.model.containsAd = containsAd;
                vm.model.showAds = containsAd;
            });
            $timeout(() => {
                ComponentUtils.equalHeight(angular.element('#check_in_boxes'));
                ComponentUtils.equalHeight(angular.element('#boxes_general'));
            });
        });
        const initializeIsAddOnEvent = $rootScope.$on('initializeIsAddOnEvent', () => {
            $rootScope.$apply(() => {
                vm.model.containsAd = false;
                vm.model.showAds = false;
            });
        });
        const executeInitCheckin = $rootScope.$on('loginContinueEvent', () => {
            CheckinSearchService.initCheckin();
        });
        $scope.$on('$destroy', bannerRenderedEvent);
        $scope.$on('$destroy', initializeIsAddOnEvent);
        $scope.$on('$destroy', executeInitCheckin);

        activate();

        ////////////////
        function activate () {
            const travelAgencies = UtilsService.getTravelAgencies(CheckinAppConstants.UNDOCHECKIN.CKI_AAVV);
            const reInvoicing = UtilsService.getTravelAgencies(CheckinAppConstants.UNDOCHECKIN.UNDOCKI);
            const travelAgent = UtilsService.getParameterByName(CheckinAppConstants.UNDOCHECKIN.TRAVEL_AGENT);
            const paymentStatus = UtilsService.getParameterByName('paymentStatus');
            const componentType = UtilsService.getParameterByName('componentType');
            const redirectStatus = paymentStatus === 'OK' || paymentStatus === 'KO' || componentType;
            const redirectionPaymentCallback = localStorageService.get('redirectionPaymentCallback');
            const urlMail = new URLSearchParams(window.location.search).get('linkmail');

            let contNextStep = localStorageService.get('contNextStep'), quadrigam = CheckinAppConstants.QUADRIGAM.SEARCH;

            contNextStep = contNextStep ? contNextStep++ : 1;
            localStorageService.set('contNextStep', contNextStep);
            UtilsService.setTitlePage(CheckinAppConstants.TITLE_PAGE.SEARCH, 2100);
            $rootScope.showMainHeader = true;
            $rootScope.showHeaders = true;
            localStorageService.set('nextStepAllowed', false);
            localStorageService.set('nextStepAllowedHome', true);
            $rootScope.$broadcast('warnUserOnBackPressed', history, $window, location, angular, () => { return ModalService.closeAllCurrentModals(); });
            CkiDatalayerUtilsService.resetDatalayer();
            const redirectionPmtContext = localStorageService.get(CheckinAppConstants.STORAGE_KEYS.PMT_REDIRECTION_CONTEXT)
            if (redirectionPmtContext?.status === CheckinAppConstants.STORAGE_KEYS.PMT_REDIRECTION_CONTEXT_STATUS_INIT) {
                localStorageService.set('nextStepAllowed', true);
                localStorageService.set(CheckinAppConstants.STORAGE_KEYS.PMT_REDIRECTION_CONTEXT, { ...redirectionPmtContext, status: CheckinAppConstants.STORAGE_KEYS.PMT_REDIRECTION_CONTEXT_STATUS_END })
                $location.path('/ibpurc');
                return;
            }
            if (!redirectionPmtContext?.status === CheckinAppConstants.STORAGE_KEYS.PMT_REDIRECTION_CONTEXT_STATUS_INIT) {
                localStorageService.remove(CheckinAppConstants.STORAGE_KEYS.PMT_VIEW_TYPE);
            }
            if (redirectionPaymentCallback?.status && redirectStatus) {
                angular.extend(redirectionPaymentCallback, { redirectStatus: redirectStatus, paymentStatus: redirectStatus });
                localStorageService.set('nextStepAllowed', true);
                localStorageService.set('redirectionPaymentCallback', redirectionPaymentCallback);
                $location.path('/ibpurc');
            } else {
                if (urlMail){
                    localStorageService.set('redirectLinkMail', true);
                }
                CheckinSearchService.initCheckin();
                if (travelAgencies && reInvoicing) {
                    vm.deInvoicingScreen = true;
                    quadrigam = CheckinAppConstants.QUADRIGAM.UN_SEARCH;
                    if (travelAgent === 'PUBLICUSER') {
                        ModalService.showGenericModal(true, true, 'ib-modal-need-login').result.then(goToIberAgencias, angular.noop);
                    }
                }
                vm.updateDatalayerByQuadrigam(quadrigam);
                $rootScope.$broadcast('warnUserOnBackPressed', history, $window, location, angular, () => { return ModalService.closeAllCurrentModals(); });
                localStorageService.set('nextStepAllowed', false);
                localStorageService.set('actualStepFlow', 'ibcose');
                vm.initModel();
            }
            if (quadrigam === CheckinAppConstants.QUADRIGAM.UN_SEARCH) UtilsService.setTitlePage('CKI_TITLE_PAGE_UNCOSE', 2100);
            /* INIT DELETE GA4 MIGRATION*/
            const extendedDatalayerInfo = {};
            extendedDatalayerInfo[CkiDatalayerConstants.DATALAYER_INFO.DYNAMIC_PRICING_SEAT] = CheckinSearchService.getDinamicPricingCookieParameter() ? 'SI' : 'NO';
            CkiDatalayerUtilsService.addDataLayerInfo(extendedDatalayerInfo);
            /* FINISH DELETE GA4 MIGRATION*/
        }

        function onError (error) {
            ModalService.finishWaiting();
        }

        function showWaitingModal () {
            ModalService.isWaiting();
        }

        function afterLogin () {
            CheckinSearchService.initCheckin();
        }

        function moreInfoRedirection () {
            RedirectionService.newNavigation($window.location.origin + CheckinAppConstants.WEB_CENTER_REDIRECT.REDIRECTION_START + CheckinAppConstants.WEB_CENTER_REDIRECT.MARKET_QUERY + $rootScope.appMarket + CheckinAppConstants.WEB_CENTER_REDIRECT.LANGUAGE_QUERY + $rootScope.appLang + CheckinAppConstants.WEB_CENTER_REDIRECT.QUADRIGAM_QUERY + CheckinAppConstants.WEB_CENTER_REDIRECT.SEARCH_MORE_INFO, CheckinAppConstants.WEB_CENTER_REDIRECT.BLANK);
        }

        function goToIberAgencias () {
            $window.location.href = 'https://www.iberiagencias.com';
        }

        /**
         * @function
         * @name openGenericModal
         * @desc opens a modal in the current view
         */
        function openGenericModal (size, tpl, anim) {
            ModalService.openGenericModal(size, tpl, anim, { idModal: CkiDatalayerConstants.DATALAYER_MODAL_ID.CHECKIN_ONLINE_MORE_INFO }).result.then(angular.noop, angular.noop);
        }

        /**
         * @function
         * @name isWaiting
         * @desc opens a modal in the current view
         */
        function isValidateForm (event) {
            if (!vm.formIberiaPlus.$valid) {
                event.preventDefault();
            }
        }

        function submitForm () {
            vm.formIberiaPlus.$submitted = true;
            if (vm.formIberiaPlus.$valid) {
                ModalService.isWaiting();
            }
        }

        function initBooking (pnr, surname) {
            UtilsService.initStorage();
            localStorageService.set('confirmationPNR', false);
            localStorageService.set('PNR', UtilsService.cleanSpaces(pnr));
            localStorageService.set('checkinSurname', UtilsService.cleanSpaces(surname));
            SearchFlightsPassengersService.searchFlighsPassengersByLocatorAndSurname(surname, UtilsService.cleanSpaces(pnr), false);
        }

        function callViewEvent () {
            /* INIT DELETE GA4 MIGRATION*/
            CkiDatalayerUtilsService.sendDatalayerEvent(CkiDatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
            /* FINISH DELETE GA4 MIGRATION*/
            CkiDatalayerUtilsService.updateDatalayerViewEvent();
        }

        function updateDatalayerByQuadrigam (quadrigam) {
            CkiDatalayerUtilsService.updateDatalayerInfo(quadrigam, null, UtilsService.isUserLogged());
            MonetateUtilsService.updateMonetateWithQuadrigam(MonetateConstants.MONETATE_INFO.SETPAGETYPE, quadrigam);
            CkiDataLayerService.setProcessAndStep(quadrigam);
            $timeout(() => {
                $rootScope.$broadcast('updateDatalayer');
                $rootScope.$broadcast('sendUpdateToMonetate');
            });
        }

        function initModel () {
            callViewEvent();
            vm.model.loginParameters = {
                language: CheckinAppConstants.lang,
                market: CheckinAppConstants.market,
                returnURL: $location.absUrl(),
                loginURL: $filter('LinksFilter')('IBERIA_NEW_LOGIN')
            };
            vm.model.containsAd = false;
            vm.model.showAds = true;
        }
    }
})();
